import React, { useEffect, useState } from "react";
import axios from "axios";
import Card from "./ Card/Card";
import "../styles/Profiles.css";

function Profiles() {
  const [lcdata, setlcData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://lcapi.cyclic.app/k_joshi");
        setlcData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  console.log(lcdata);

  return (
    <div class="profiles">
      <iframe
        title="still working"
        src="https://giphy.com/embed/LK2DwwVWAG5vmswb7U"
        width="480"
        height="480"
        frameBorder="0"
        class="giphy-embed"
        allowFullScreen
      ></iframe>
      <p>
      </p>
      {Object.keys(lcdata).length > 1 && (
        <Card
          easySolved={lcdata.easySolved}
          mediumSolved={lcdata.mediumSolved}
          hardSolved={lcdata.hardSolved}
          totalSolved={lcdata.totalSolved}
          allQuestionsCount={lcdata.allQuestionsCount}
          matchedUser={lcdata.matchedUser}
          userContestRanking={lcdata.userContestRanking}
          userContestRankingHistory={lcdata.userContestRankingHistory}
        />
      )}
    </div>
  );
}

export default Profiles;
